$(document).on("change",".custom_complentary_product_select",function(){
  var v = $(this).val();
  console.log(v, 'vvvvvvv')
  $(this).parents('.select_cst_btn').find('input[name="id"]').val(v);
})

$(document).on("click",".template_modal_open",function(){
    var m = $(this).attr('atr_modal');
	$(".template_modal."+m).fadeIn();
});

$(document).on("click",".template_modal_close_btn, .template_modal_overlay",function(){
	$(".template_modal").fadeOut();
});

var img_swiper_popup = new Swiper(".img_swiper_popup", {
  pagination: {
    el: ".swiperimg_swiper_popup-pagination",
    dynamicBullets: true,
  },
});

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    },
  },
});

var swiperP = new Swiper(".mySwiper_Personalized_Items", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 1.2
    },
    768: {
      slidesPerView: 2.2
    },
    1024: {
      slidesPerView: 2.5
    },
  },
  autoplay: {
    delay: 2000,
  }
});

var swiperV = new Swiper(".swiper_vertical", {
  slidesPerView: 1,
  breakpoints: {
    640: {
      direction: "horizontal",
    },
    1061: {
      direction: "vertical",
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 4000,
  }
});

var init = false;
var swiperM;
function swiperCard() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      swiperM = new Swiper(".slider-cards-js", {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 12,
      });
    }
  } else if (init) {
    swiperM.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);

// const swiperInfinite = new Swiper('.promo-scrollbar-swiper', {
//   loop: true,
//   freeMode: true,
//   autoplay: {
//     delay: 0,
//     // pauseOnMouseEnter:true,
//     disableOnInteraction:false,
//   },
//   loopAddBlankSlides:true,
//   cssMode:true,
//   slidesPerView: 1,
//   speed: 5000,
//   grabCursor: true,
//   loopAdditionalSlides: 1,
// });
$('.header__icon_wrapper .cls').click(function() {
  $('summary.header__icon.header__icon--menu.header__icon--summary').trigger('click');
});


$(document).on('click', '.promo-scrollbar-parent-wrapper', function() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'YncAUC']);
});

$(document).on('click', '.template-product.pro-drawer-pushtoleft .overlaydrawer', function() {
    $('body').removeClass('pro-drawer-pushtoleft');
    $drawerRight.removeClass('pro-drawer-open');
});

$('.accordian_title_ele').click(function() {
  $('.accordian_title_ele').removeClass('active');
  $(this).addClass('active');
  // if ($(this).hasClass('active')) {} else {
  // $('.accordion__content').hide();
  // }
  $(this).siblings('.accordion__content').slideToggle();
});

$(document).ready(function() {  
	$drawerRight = $('.pro-drawer-right');
	$cart_list = $('.pro-drawer-btn, .pro-drawer-close-btn');
		
	$cart_list.click(function() {
		$(this).toggleClass('active');
		$('body').toggleClass('pro-drawer-pushtoleft');
		$drawerRight.toggleClass('pro-drawer-open');
	});
	
	//BEGIN
	$(".ele_accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp(400);
			$(".ele_accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
	//END
	
});


var imagesBundle = [];
var imagesBundleVal = [];
$(document).on('click', 'li.alphabetical_icon', function() {
  if ($(this).hasClass('vnot_available')) {} else {
    var im = $(this).children('img').attr('src');
var id = $(this).attr('dataid');
var price = $(this).attr('dataprice');
    var typeoitemin = $(this).find('img').attr('type_of_necklace');
    var dataproducttitle = $(this).attr('dataproducttitle');
    
    var ttitle = $(this).attr('datatitle');
    imagesBundle.push({image: im, id: id, price: price, title: ttitle, pkey: dataproducttitle, typeoitem: typeoitemin});
    
    imagesBundleVal.push({quantity: 1, id: id});
    var productCount = imagesBundle.length - 1;
  
    if (imagesBundle.length > 0) {
      $('.product-form__submit_builder span').html('ADD TO BASKET');
      $('.product-form__submit_builder').removeAttr('disabled');
    } else {
      $('.product-form__submit_builder span').html('Select Letters');
      $('.product-form__submit_builder').attr('disabled', 'disabled');
    }
    if (imagesBundle.length > 8) {
      $('.errormessage_builder').html('<p>Maximum 8 letters allowed</p>');
      $('.builderChainContent p.fst').html('YOU HAVE REACHED THE MAXIUMUM OF 8 CHARACTERS');
      setTimeout(function() {
        $('.errormessage_builder').html('');
      }, 2500);
      imagesBundle.splice(8, 1);
      imagesBundleVal.splice(8, 1);
      return true;
    }
    
    $('.builderChainContent p.fst').html('CLICK ON THE LETTERS');
    if (imagesBundle.length == 8) {
      $('.builderChainContent p.fst').html('YOU HAVE REACHED THE MAXIUMUM OF 8 CHARACTERS');
    }
    var startPosition = 6;
    var layout = '';
    if(imagesBundle.length % 2 == 0) {
        var layout = 'even'; 
        var startPosition = 6 - productCount/2 + 1;
    } else {
        var layout = 'odd'; 
        var startPosition = 5.5 - productCount/2 + 1;
    }
    startPosition = Math.floor(startPosition);
    
    $('.necklacebuilder_value').val(JSON.stringify(imagesBundleVal));
    $('.necklacebuilder_value_properties').val(JSON.stringify(imagesBundle));
    $('.builderChainPoint').hide().html('');
    if (imagesBundle.length == 1) {        
        var variant = imagesBundle[0].id;
      
        var typeoitem = imagesBundle[0].typeoitem;
        var variantImage = imagesBundle[0].image;
        $('.builderChainPoint[data-point="6"][data-style="odd"]').attr('typeoitem', typeoitem);
        $('.builderChainPoint[data-point="6"][data-style="odd"]').html('<img src="' + variantImage + '" /><button class="remove_selected_from_builder" dataindex="0" dataid="'+variant+'"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"> <rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/> <path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/> <path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/> </svg></button>')
    } else {   
      $.each(imagesBundle, function(index) {
          // if(index>0) {
              var variant = imagesBundle[index].id;
        var typeoitem = imagesBundle[index].typeoitem;
              var variantImage = imagesBundle[index].image;
              $('.builderChainPoint[data-point=' + startPosition + '][data-style=' + layout + ']').attr('typeoitem', typeoitem);
              $('.builderChainPoint[data-point=' + startPosition + '][data-style=' + layout + ']').html('<img src="' + variantImage + '" /><button class="remove_selected_from_builder" dataindex="'+index+'" dataid="'+variant+'"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"> <rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/> <path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/> <path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/> </svg></button>')
              startPosition++;
          // }
    
      });
    }

    let heartsLength = imagesBundle.filter((v) => {
        return v.pkey === 'heart';
    });
    let balloonsLength = imagesBundle.filter((v) => {
        return v.pkey === 'balloon';
    });
    let silverLength = imagesBundle.filter((v) => {
        return v.pkey === 'silver';
    });

    
    $('.letters_pricing.heart .nmbs').html(heartsLength.length);
    var priceheart = 0;
    if (heartsLength && heartsLength.length > 0 && heartsLength[0].price) {
      $('.letters_pricing.heart .prcing').html(heartsLength[0].price);    
      priceheart = heartsLength[0].price.replace('£', '');
    }
    
    $('.letters_pricing.balloon .nmbs').html(balloonsLength.length);
    var priceballoon = 0;
    if (balloonsLength && balloonsLength.length > 0 && balloonsLength[0].price) {
      priceballoon = balloonsLength[0].price.replace('£', '');
      $('.letters_pricing.balloon .prcing').html(balloonsLength[0].price);
    }
    
    $('.letters_pricing.silver .nmbs').html(silverLength.length);
    var pricesilver = 0;
    if (silverLength && silverLength.length > 0 && silverLength[0].price) {
      pricesilver = silverLength[0].price.replace('£', '');
      $('.letters_pricing.silver .prcing').html(silverLength[0].price);
    }
    
    var baseProductPrice = parseFloat($('.builder_base_price').val());
    var inPrice = price.replace('£', '');
    
    
    var lettersPrice = parseFloat((parseFloat(pricesilver)*parseInt(silverLength.length)) + (parseFloat(priceballoon)*parseInt(balloonsLength.length)) + (parseFloat(priceheart)*parseInt(heartsLength.length)));
    var totalBuilderPrice = baseProductPrice+lettersPrice;
    $('.tprice').html('£'+totalBuilderPrice);
    
    var selected_products = '<ul>';
    $.each(imagesBundle, function(index) {
      var variant = imagesBundle[index].id;
      var variantImage = imagesBundle[index].image;
  
      selected_products += '<li><img src="'+variantImage+'"><button class="remove_selected_from_builder"  dataindex="'+index+'" dataid="'+variant+'">Remove</button></li>';
    });
    selected_products += '</ul>';
    if (imagesBundle.length > 0) {
      $('.selected_letters_and_pro').addClass('active');
    } else {
      $('.selected_letters_and_pro').removeClass('active');
    }
    $('.selected_letters_and_pro').html(selected_products);
    
    setTimeout(function(){
        $('.builderChainPoint').fadeIn(500, function(){
            $('.builderProductAdd').html('Add').removeClass('disabled');
        });
    }, 500)
  }
});

$(document).on('click', '.remove_selected_from_builder', function() {
  $('.builderChainContent p.fst').html('CLICK ON THE LETTERS');
  var idd = $(this).attr('dataid');
  var eindex = $(this).attr('dataindex');
  var price = imagesBundle[0].price;
  // imagesBundle = imagesBundle.filter(object => {
  //   return object.id !== idd;
  // });

  imagesBundle.splice(eindex, 1);
  
  // imagesBundleVal = imagesBundleVal.filter(object => {
  //   return object.id !== idd;
  // });
  imagesBundleVal.splice(eindex, 1);
  if (imagesBundle.length > 0) {
    $('.product-form__submit_builder span').html('ADD TO BASKET');
    $('.product-form__submit_builder').removeAttr('disabled');
  } else {
    $('.product-form__submit_builder span').html('Select Letters');
    $('.product-form__submit_builder').attr('disabled', 'disabled');
  }
  var productCount = imagesBundle.length - 1;


  var startPosition = 6;
  var layout = '';
  if(imagesBundle.length % 2 == 0) {
      var layout = 'even'; 
      var startPosition = 6 - productCount/2 + 1;
  } else {
      var layout = 'odd'; 
      var startPosition = 5.5 - productCount/2 + 1;
  }
  startPosition = Math.floor(startPosition);
  
  $('.necklacebuilder_value').val(JSON.stringify(imagesBundleVal));
  $('.necklacebuilder_value_properties').val(JSON.stringify(imagesBundle));
  $('.builderChainPoint').hide().html('');
  if (imagesBundle.length == 1) {        
      var variant = imagesBundle[0].id;
        var typeoitem = imagesBundle[0].typeoitem;
      var variantImage = imagesBundle[0].image;
      $('.builderChainPoint[data-point="6"][data-style="odd"]').attr('typeoitem', typeoitem);
      $('.builderChainPoint[data-point="6"][data-style="odd"]').html('<img src="' + variantImage + '" /><button class="remove_selected_from_builder" dataindex="0" dataid="'+variant+'"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"> <rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/> <path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/> <path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/> </svg></button>')
  } else {   
    $.each(imagesBundle, function(index) {
        // if(index>0) {
            var variant = imagesBundle[index].id;
            var variantImage = imagesBundle[index].image;
        var typeoitem = imagesBundle[index].typeoitem;
            $('.builderChainPoint[data-point=' + startPosition + '][data-style=' + layout + ']').attr('typeoitem', typeoitem);
            $('.builderChainPoint[data-point=' + startPosition + '][data-style=' + layout + ']').html('<img src="' + variantImage + '" /><button class="remove_selected_from_builder"  dataindex="'+index+'" dataid="'+variant+'"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"> <rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/> <path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/> <path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/> </svg></button>')
            startPosition++;
        // }
  
    });
  }

  
    let heartsLength = imagesBundle.filter((v) => {
        return v.pkey === 'heart';
    });
    let balloonsLength = imagesBundle.filter((v) => {
        return v.pkey === 'balloon';
    });
    let silverLength = imagesBundle.filter((v) => {
        return v.pkey === 'silver';
    });

      $('.letters_pricing.heart .nmbs').html(heartsLength.length);
    var priceheart = 0;
    if (heartsLength && heartsLength.length > 0 && heartsLength[0].price) {
      $('.letters_pricing.heart .prcing').html(heartsLength[0].price);    
      priceheart = heartsLength[0].price.replace('£', '');
    }
    
    $('.letters_pricing.balloon .nmbs').html(balloonsLength.length);
    var priceballoon = 0;
    if (balloonsLength && balloonsLength.length > 0 && balloonsLength[0].price) {
      priceballoon = balloonsLength[0].price.replace('£', '');
      $('.letters_pricing.balloon .prcing').html(balloonsLength[0].price);
    }
    
    $('.letters_pricing.silver .nmbs').html(silverLength.length);
    var pricesilver = 0;
    if (silverLength && silverLength.length > 0 && silverLength[0].price) {
      pricesilver = silverLength[0].price.replace('£', '');
      $('.letters_pricing.silver .prcing').html(silverLength[0].price);
    }
    
    var baseProductPrice = parseFloat($('.builder_base_price').val());
    var inPrice = price.replace('£', '');
    
    
    var lettersPrice = parseFloat((parseFloat(pricesilver)*parseInt(silverLength.length)) + (parseFloat(priceballoon)*parseInt(balloonsLength.length)) + (parseFloat(priceheart)*parseInt(heartsLength.length)));
  
  var totalBuilderPrice = baseProductPrice+lettersPrice;
  $('.tprice').html('£'+totalBuilderPrice);
  
  var selected_products = '<ul>';
  $.each(imagesBundle, function(index) {
    var variant = imagesBundle[index].id;
    var variantImage = imagesBundle[index].image;

    selected_products += '<li><img src="'+variantImage+'"><button class="remove_selected_from_builder" dataindex="'+index+'" dataid="'+variant+'">Remove</button></li>';
  });
  selected_products += '</ul>';
  
  if (imagesBundle.length > 0) {
    $('.selected_letters_and_pro').addClass('active');
  } else {
    $('.selected_letters_and_pro').removeClass('active');
  }
  $('.selected_letters_and_pro').html(selected_products);
  
  setTimeout(function(){
      $('.builderChainPoint').fadeIn(500, function(){
          $('.builderProductAdd').html('Add').removeClass('disabled');
      });
  }, 500)
});

$('.product-form__submit_builder').click(function(e) {  
  e.preventDefault();
  e.stopPropagation();
  var that = $(this);
  if (that.hasClass('propage') && $(this).attr('disabled')) {              
    return;
  }

  var itemsss = $('.necklacebuilder_value').val();
  var id = $(this).attr('dataid');
  var items_f = [];
  if (itemsss) {
    items_f = JSON.parse(itemsss);
  }

  if (items_f.length == 0) {
    return;
  }
  const cartLink = document.querySelector('#cart-icon-bubble');
  $(this).find('span').hide();
  $(this).find('.loading__spinner').removeClass('hidden');
  var current_product_value = $('.current_product_value').val();

  var items_properties = $('.necklacebuilder_value_properties').val();
  // console.log(JSON.parse(items_properties))
  var items_properties_json = JSON.parse(items_properties);
  var titleArray = items_properties_json.map(function (el) { return el.title; });
  let titleString = titleArray.toString();


  // console.log(items_f, 'items_fitems_f')
  var current_pro = {
    id: current_product_value,
    quantity: 1,
    properties: {
      letters_order: titleString
    }
  }
  
  items_f.push(current_pro);
  var data = {
    items: items_f
  }
  
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(res) {
        if ($('cart-drawer-items').hasClass('is-empty')) {
          $.ajax({
            type: 'GET',
            url: `${routes.cart_url}?view=fullcartdrawer`,
            success: function(htm) {
              $('cart-drawer ').removeClass('is-empty');
              $('cart-drawer ').html(htm);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');
              $('.modal').removeClass('is-visible');
              if (that.hasClass('propage')) {              
                $('cart-drawer').addClass('animate active')
              }
            },
            error: function(err) {
              console.log(err);   
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');               
            }
          });          
        } else {
          $.ajax({
            type: 'GET',
            url: `${routes.cart_url}?view=rendercart`,
            success: function(htm) {
              $('#CartDrawer-CartItems').html(htm);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');
              $('.modal').removeClass('is-visible');
              if (that.hasClass('propage')) {              
                $('cart-drawer').addClass('animate active')
              }
            },
            error: function(err) {
              console.log(err);   
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');               
            }
          });
        }

        jQuery.getJSON('/cart.js', function(cart) {
          if ($('.cart-count-bubble')[0]) {
            $('.cart-count-bubble span').html(cart.item_count);
          } else {
            var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span> </div>'
            $('#cart-icon-bubble').append(dt);
          }
          cartLink.click();
        });
        
      },
      error: function(err) {
        console.log(err);      
        that.find('span').show();
        if (err && err.responseJSON && err.responseJSON.description) {
          $('.product-form__submit_builder').after('<p class="error">'+err.responseJSON.description+'</p>');
          setTimeout(function() {
            $('.error').remove();
          }, 2500);
        }
        that.find('.loading__spinner').addClass('hidden');            
      }
  });
});  

setTimeout(function() {
  $('main#MainContent').css('opacity', '1');
}, 750)
$('ul.builder_tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.builder_tabs li').removeClass('current');
    $('.builder_tabstabcontent').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
    var sp = $(this).find('span').html();
    $('.current_builder_active_tabs').html(sp);
});

$('ul.tabs li').click(function() {
  $('.tab-content').css('opacity', '0');
  var tab_id = $(this).attr('data-tab');
  $('ul.tabs li').removeClass('current');
  $('.tab-content').removeClass('current');
  $(this).addClass('current');
  $("#"+tab_id).addClass('current');
  setTimeout(function() {
    $('.tab-content').css('opacity', '1');
    checkClasses();
  }, 250);
});

$(document).ready(function() {
    if ($(".videovideo_desc")[0]){
      $(".videovideo_desc").get(0).play();
    }
    if ($(".videovideo_mobile")[0]){
      $(".videovideo_mobile").get(0).play();
    }
    var chainObj = {};
    $('button.bundle_addon_button').click(function() {
      
      if ($(this).hasClass('special_color_item')) {
        $('.bundle_addon_button').removeClass('active');
        $(this).addClass('active');  
      } else {
        $(this).toggleClass('active');    
      }
      if ($(this).hasClass('active')) {
        var src = $(this).attr('datasrc');
        var datatitle = $(this).attr('datatitle');
        var vid = $(this).attr('dataid');
        var vprice = parseFloat($(this).attr('dataprice'));
        chainObj = {
          "src": src,
          "vid": vid,
          "datatitle": datatitle,
          "vprice": vprice
        };
        $('.chain_count strong').html('£'+(vprice/100));
        $('.chain_count span').html('1');
      } else {
        chainObj = {};
        $('.chain_in').remove();
        $('.bundle_addon_button').removeClass('active');
        $('.chain_count span').html('0');
        $('.chain_count strong').html('0');
      }
      renderBundleElements();
    });
  
    if((window.location.href).includes('heartletters=true')) {
      $('li.tab-link[data-tab="builder_tabstabcontent-2"]').click();
    }
    if((window.location.href).includes('goldletters=true')) {
      $('li.tab-link[data-tab="builder_tabstabcontent-3"]').click();
    }
  
  	var drawerRight = $('.ele_cart-drawer-right');
	var cart_list = $('.drawer_open_builder');
  
	cart_list.click(function() {
      $(this).toggleClass('active');     
      var st = $(this).attr('atr');
      $('.common_status_manage').hide();
      if (st == 'delivery_returns') {        
        $('.drawer_deliverycontent').show();
      } else if (st == 'inspiration') {        
        $('.drawer_inspiration').show();
      } else if (st == 'edit_necklacebuilder') {        
        $('.drawer_edit_necklacebuilder').show();
      } else {        
        $('.drawer_description').show();
      }
      
      $("#ol").toggleClass("overlay_drawer");
      $('body').toggleClass('ele_cart-drawer-pushtoleft');
      drawerRight.toggleClass('ele_cart-drawer-open');
	});

    $(document).on('click', '.overlay_drawer, .ele_cart-drawer-close-btn, .ele_cart-drawer-close-back', function() {
      $("#ol").removeClass("overlay_drawer");
      $('body').removeClass('ele_cart-drawer-pushtoleft');
      drawerRight.removeClass('ele_cart-drawer-open');
    });

    var elementsArray = [];
    function renderBundleElements() {
      var selected_items = '';

      if (chainObj && chainObj.vid) {
        $('.selected_items_ele').addClass('active');
        selected_items += '<li class="chain_in"> <img src="'+chainObj.src+'"> <button class="remove_selected_chain_from_pack" dataid="'+chainObj.vid+'">Remove</button> </li>';
        if (elementsArray && elementsArray.length > 0) {
          selected_items += '<li class="chain_in"> <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none"> <path d="M19.433 20.8534H15.377V19.0774H19.433V15.0454H21.209V19.0774H25.217V20.8534H21.209V24.8854H19.433V20.8534Z" fill="#BBBBBB"></path> </svg> </li>';
        }
      } else {
        $('.selected_items_ele').removeClass('active');
        $('.chain_in').remove();
      }

      var elementsTotal = 0;
      if (elementsArray && elementsArray.length > 0) {
        $('.selected_items_ele').addClass('active');
        elementsArray.forEach(function(v, i) {
          elementsTotal = parseFloat(elementsTotal) + parseFloat(v.vprice);
          if (v && v.src) {
            selected_items += '<li> <img src="'+v.src+'"> <button class="remove_selected_from_pack" dataindex="'+i+'" dataid="'+v.vid+'">Remove</button> </li>';
          } else {
            selected_items += '<li> <span class="vtitle_wrp_title">'+v.vtitle+'</span> <button class="remove_selected_from_pack" dataindex="'+i+'" dataid="'+v.vid+'">Remove</button> </li>';
          }
        });
        var elementsTotalFinal = '£'+(elementsTotal/100).toFixed(2);
        $('.letters_count strong').html(elementsTotalFinal.replace('.00', ''));
      } else {
        if (chainObj && chainObj.vid) {} else {
          $('.selected_items_ele').removeClass('active');
        }
      }

      var totalBundlePrice = elementsTotal;
      if (chainObj && chainObj.vprice) {
        totalBundlePrice = parseFloat(elementsTotal) + parseFloat(chainObj.vprice);
      }
      var totalBundlePriceFinal = '£'+(totalBundlePrice/100)
      $('.total_bundle_price').html(totalBundlePriceFinal);
      setTimeout(() => {
        $('.product__title+div span.price-item.price-item--regular').html(totalBundlePriceFinal);
      },50)
      $('.letters_count span').html(elementsArray.length);
      $('.selected_items_ele_in ul').html(selected_items);
    }
  
    function removeObjectWithId(arr, id) {
      const objWithIdIndex = arr.findIndex((obj) => obj.vid === id);
      arr.splice(objWithIdIndex, 1);
      return arr;
    }

    $('.bundle_addon_button.special_color_item.active_one').trigger('click');
    $(document).on('click', '.variant_image_true', function(e) {
  e.preventDefault();

  var $label = $(this);
  var $meta = $label.find('.labelimgvariant');
  var $input = $label.prev('input');

  if ($input.hasClass('disabled') || $input.is(':disabled')) {
    return;
  }

  var src = $meta.attr('src') || $meta.find('img').attr('src') || '';
  var vid = $meta.attr('vid') || $label.attr('vid') || '';
  var vprice = $meta.attr('vprice') || '0';
  var vtitle = $meta.attr('vtitle') || $.trim($label.text());
  var vavailable = parseInt($label.attr('vavailable'));

  if (isNaN(vavailable)) vavailable = 999;

  if (!vid) {
    console.log('Missing VID → FIX YOUR HTML');
    return;
  }

  var data_element = {
    src: src,
    vid: vid,
    vprice: vprice,
    vtitle: vtitle
  };

  if ($('body').hasClass('alpha_charm_builder')) {

    let counter = 0;
    for (let i = 0; i < elementsArray.length; i++) {
      if (elementsArray[i].vid === vid) counter++;
    }

    if (counter >= vavailable) {
      if ($("variant-selects .error")[0]){
        $('variant-selects .error').html('Out of stock');
      } else {
        $('.product__info-wrapper variant-selects').append('<p class="error">Out of stock</p>');
      }
      setTimeout(() => $('.error').remove(), 2500);
      return;
    }
  }

  elementsArray.push(data_element);
  renderBundleElements();
});

    $(document).on('click','button.remove_selected_from_pack', function() {
      var id = $(this).attr('dataid');
      elementsArray = removeObjectWithId(elementsArray, id);
      renderBundleElements();
    });
  
    $(document).on('click','button.remove_selected_chain_from_pack', function() {
      $('.chain_in').remove();
      $('.bundle_addon_button').removeClass('active');
      $('.chain_count span').html('0');
      $('.chain_count strong').html('0');
      chainObj = {};
    });


  
$('.product-bundle_form__submit').click(function(e) {  
  e.preventDefault();
  e.stopPropagation();
  var that = $(this);
  if ($(this).attr('disabled')) {              
    return;
  }
  
  var items_f = [];
  var chainObjCheck = false;
  if (chainObj && chainObj.vid) {
    chainObjCheck = true;
  }
  if (elementsArray.length == 0 && !chainObjCheck) {
    return;
  }
  const cartLink = document.querySelector('#cart-icon-bubble');
  $(this).find('span').hide();
  $(this).find('.loading__spinner').removeClass('hidden');


  // console.log(items_f, 'items_fitems_f')

  
  var vstring = '';
  var properties_ref_order = {};
  elementsArray.forEach(function(v, i) {
      vstring = vstring+' '+v.vtitle;
  });
  if (vstring != '') {
    properties_ref_order = {
      "Letters Order": vstring
    }
  }
  
  if (chainObj && chainObj.vid) {
    var current_pro = {
      id: chainObj.vid,
      quantity: 1,
      properties: properties_ref_order
    }
    items_f.push(current_pro);
  }
  var properties_ref = {};
  if (chainObj && chainObj.datatitle) {
  properties_ref = {
    'Ref': chainObj.datatitle+'-'+chainObj.vid
  }
  }
  elementsArray.forEach(function(v, i) {
      var current_pro = {
        id: v.vid,
        quantity: 1,
        properties: properties_ref
      }
      items_f.push(current_pro);
  });
  
  var data = {
    items: items_f
  }
  
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(res) {
          $.ajax({
            type: 'GET',
            url: `${routes.cart_url}?view=fullcartdrawer`,
            success: function(htm) {
              $('cart-drawer ').removeClass('is-empty');
              $('cart-drawer ').html(htm);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');
              $('.modal').removeClass('is-visible');
              // if (that.hasClass('propage')) {              
                $('cart-drawer').addClass('animate active')
              // }  
              elementsArray = [];
              renderBundleElements();
            },
            error: function(err) {
              console.log(err);   
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');               
            }
          });       

        jQuery.getJSON('/cart.js', function(cart) {
          if ($('.cart-count-bubble')[0]) {
            $('.cart-count-bubble span').html(cart.item_count);
          } else {
            var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span> </div>'
            $('#cart-icon-bubble').append(dt);
          }
          cartLink.click();
        });
        
      },
      error: function(err) {
        console.log(err);      
        that.find('span').show();
        if (err && err.responseJSON && err.responseJSON.description) {
          $('.product-form__submit_builder').after('<p class="error">'+err.responseJSON.description+'</p>');
          setTimeout(function() {
            $('.error').remove();
          }, 2500);
        }
        that.find('.loading__spinner').addClass('hidden');            
      }
  });
});  


  $('.product-ring_stack_form__submit').click(function(e) {  
    e.preventDefault();
    e.stopPropagation();
    var that = $(this);
    if ($(this).attr('disabled')) {              
      return;
    }
    
    var items_f = [];

    const cartLink = document.querySelector('#cart-icon-bubble');
    $(this).find('span').hide();
    $(this).attr('disabled', 'disabled');
    $(this).find('.loading__spinner').removeClass('hidden');
  
    var selected_string = [];
    var selected_val = [];
    $('.rings_variants').each(function() {
      $(this).find('.rings_variants_select').each(function() {
        var v = $(this).find('select').val();
        selected_val.push(v);
      });
      selected_string.push(selected_val.join(" / "));
      selected_val = [];
    });
    $('.visually_hidden_option').each(function(i, v) {
      var id = $(this).find('option[title="'+selected_string[i]+'"]').val();
      var item = {
        'id': id,
        'quantity': 1
      }
      items_f.push(item);
    });
    

    var data = {
      items: items_f
    }
      
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(res) {
          $.ajax({
            type: 'GET',
            url: `${routes.cart_url}?view=fullcartdrawer`,
            success: function(htm) {
              $('cart-drawer ').removeClass('is-empty');
              $('cart-drawer ').html(htm);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');
              $('.modal').removeClass('is-visible');
              $('cart-drawer').addClass('animate active');
              $('.product-ring_stack_form__submit').removeAttr('disabled');
            },
            error: function(err) {
              console.log(err);   
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');               
            }
          });       

        jQuery.getJSON('/cart.js', function(cart) {
          if ($('.cart-count-bubble')[0]) {
            $('.cart-count-bubble span').html(cart.item_count);
          } else {
            var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span> </div>'
            $('#cart-icon-bubble').append(dt);
          }
          cartLink.click();
        });
        
      },
      error: function(err) {
        console.log(err);      
        that.find('span').show();
        that.find('.loading__spinner').addClass('hidden');        

        if (err && err.responseJSON && err.responseJSON.message) {
          $('.rings_error').text(err.responseJSON.message);
        }
        $('.product-ring_stack_form__submit').removeAttr('disabled');

        setTimeout(function() {
          $('.rings_error').text('');
        }, 3000);
      }
  });
    
  });
});

// $(document).on('click', 'button.btn.pplr-c-button.pplr-btn.ptc_button', function() {
//   setTimeout(()=> {
//     var sty = $('.cstmfy_personalize_text.pplr_background').html();
//     if (sty != '') {
//       $('.perror_personalised_message').html('<strong>Please note</strong> - If personalising your order, it will be dispatched on the 8th January 2026');
//     } else {
//       $('.perror_personalised_message').html('');
//     }
//   }, 250)
// })


